// extracted by mini-css-extract-plugin
export var bottom = "FloatingBox-module--bottom--f57a7";
export var box = "FloatingBox-module--box--152fa";
export var center = "FloatingBox-module--center--e67d4";
export var left = "FloatingBox-module--left--21ee2";
export var right = "FloatingBox-module--right--25519";
export var top = "FloatingBox-module--top--6d1e0";